var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTutorialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9334 3.23291C14.3178 0.0234619 11.556 2.30391 11.5197 4.76219C11.5197 8.42187 15.8984 11.4257 16.9334 11.4257C17.9685 11.4257 22.3473 8.42187 22.3473 4.76219C22.311 2.30391 19.5492 0.0234619 16.9334 3.23291Z",
    stroke: "#4A57DA",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92622 11.4525L3.06115 11.3823C4.37093 11.3012 5.68539 11.4231 6.95794 11.7436L8.84238 12.2182C9.86595 12.476 10.5451 13.4461 10.4371 14.4961C10.3106 15.7252 9.16608 16.5877 7.94972 16.3703L6.17191 16.0527L12.4401 17.1768L18.9326 15.6358C19.983 15.3866 21.0404 16.0194 21.3173 17.0627C21.5744 18.0317 21.071 19.0408 20.1421 19.4182L14.9488 21.5282C12.4225 22.5547 9.60755 22.619 7.03709 21.7089L1.65271 19.8026",
    stroke: "#4A57DA",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTutorialsIcon);
export default __webpack_public_path__ + "static/media/active-tutorialsIcon.da064865abc587e380147a672cd22e05.svg";
export { ForwardRef as ReactComponent };